import angular from 'angular';
import {
    MESSAGE_TYPE,
    ILoginMessage
} from '@common/model/constants';
import {
    JavaApiAdapterService
} from '@common/apiadapter/javaapi.service';


export class SplashScreenController {
    static $inject = [
        '$uibModalInstance',
        'messages',
        'ApiAdapterService'
    ];

    public messages: ILoginMessage[] = [];
    public hideMeNextTime: boolean = false;
    public MESSAGE_TYPE = MESSAGE_TYPE;


    constructor(
        private $uibModalInstance: any,
        private messageData: any,
        private ApiAdapterService: JavaApiAdapterService
    ) {
        this.messages =
            messageData.messages || [];

    }

    closePopup = (): void => {
        if (this.hideMeNextTime) {
            this.ApiAdapterService
                .updateMessageDismiss()
                .finally(() => {
                    this.$uibModalInstance.close();
                });
        } else {
            this.$uibModalInstance.close();
        }
    }
}

angular.module('eCareVault.common.popUp')
    .controller(
        'SplashScreenController',
        SplashScreenController
    );
